import React from "react";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/core/ProtectedRoute";
import ViewClaim from "./pages/ViewClaim";
import ErrorBoundary from "./components/ErrorBoundary";
import SetupAxiosInterceptors from "./utils/interceptor.js";
import OnBoardHosp from "./pages/OnBoardHosp";
import ClaimProcessingReport from "./pages/ClaimProcessingReport";
import ResponseLogReport from "./pages/ResponseLogReport";
import Iframe from "./pages/Iframe.jsx";
import SupportAllocation from "./pages/SupportAllocation.js";
import OnBoardRoom from "./pages/OnBoardRoom";
import {ChkPointLogs} from "./pages/ChkPointLogs";

const RoutingPage = () => {
    let routes = [
        {
            path: "/",
            element: (
                <ProtectedRoute>
                    <SetupAxiosInterceptors/>
                    <Dashboard/>
                </ProtectedRoute>
            ),
            errorElement: <ErrorBoundary/>,
        },
        {
            path: "/support",
            element: (
                <>
                    <ProtectedRoute>
                        <SetupAxiosInterceptors/>
                        <SupportAllocation/>
                    </ProtectedRoute>
                </>
            ),
            errorElement: <ErrorBoundary/>,
        },
        {
            path: "/claim/:claimId",
            element: (
                <ProtectedRoute>
                    <SetupAxiosInterceptors/>
                    <ViewClaim/>
                </ProtectedRoute>
            ),
            errorElement: <ErrorBoundary/>,
        },
        {
            path: "/claim",
            element: (
                <>
                        <SetupAxiosInterceptors/>
                        <Iframe></Iframe>
                </>
            ),
            errorElement: <ErrorBoundary/>,
        },
        {
            path: "/login",
            element: (
                <>
                        <SetupAxiosInterceptors/>
                        <LoginPage mode={"signin"}/>
                </>
            ),
            errorElement: <ErrorBoundary/>,
        },
        {
            path: "/signup",
            element: (
                <>
                    <ProtectedRoute>
                        <SetupAxiosInterceptors/>
                        <LoginPage mode={"signup"}/>
                    </ProtectedRoute>
                </>
            ),
            errorElement: <ErrorBoundary/>,
        },
        {
            path: "/onboarding-hospital",
            element: (
                <>
                    <ProtectedRoute>
                        <SetupAxiosInterceptors/>
                        <OnBoardHosp/>
                    </ProtectedRoute>
                </>
            ),
            errorElement: <ErrorBoundary/>,
        },
        {
            path: "/onboarding-rooms",
            element: (
                <>
                    <ProtectedRoute>
                        <SetupAxiosInterceptors/>
                        <OnBoardRoom/>
                    </ProtectedRoute>
                </>
            ),
            errorElement: <ErrorBoundary/>,
        },
        {
            path: "/report-claim-processing",
            element: (
                <>
                    <ProtectedRoute>
                        <SetupAxiosInterceptors/>
                        <ClaimProcessingReport/>
                    </ProtectedRoute>
                </>
            ),
            errorElement: <ErrorBoundary/>,
        },
        {
            path: "/report-response-log",
            element: (
                <>
                    <ProtectedRoute>
                        <SetupAxiosInterceptors/>
                        <ResponseLogReport/>
                    </ProtectedRoute>
                </>
            ),
            errorElement: <ErrorBoundary/>,
        },
        {
                path: "/checkpointLogs",
            element: (
                <>
                    <ProtectedRoute>
                        <SetupAxiosInterceptors/>
                        <ChkPointLogs />
                    </ProtectedRoute></>

            ),
            errorElement: <ErrorBoundary/>,
        }
    ];

    const router = createBrowserRouter(routes);

    return <RouterProvider router={router}/>;
};
export default RoutingPage;
